import { render } from "./gql.vue?vue&type=template&id=0c0a8022"
import script from "./gql.vue?vue&type=script&lang=js"
export * from "./gql.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__